import React from 'react';
import styled, { useTheme } from 'styled-components';

import { colors } from '../../../core';
import BaseModal from '../BaseModal';
import Heading from '../Heading';
import Icon from '../Icon';
import Text from '../Text';

export interface InfoCardProps {
  headerText: string;
  bodyText: string;
  icon: {
    name: string;
    color: string;
    size?: number;
    viewSize?: number;
  };
  handleClose?: () => void;
}

const InfoCardContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 3px 0;
  border-radius: 4px;
  width: 620px;
  padding-bottom: 10px;
  padding-top: 40px;
`;

const HeaderStyle = styled(Heading)`
  margin-top: 20px;
  color: ${({ theme }) => theme.fontColor || colors.ash};
`;

const CloseIconStyle = styled(Icon)`
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
`;

const InfoCard = ({ icon, headerText, bodyText, handleClose }: InfoCardProps) => {
  const theme = useTheme();
  return (
    <BaseModal onClose={handleClose}>
      <InfoCardContainer>
        {handleClose ? (
          <CloseIconStyle
            onClick={handleClose}
            type="close"
            color={theme.iconColor || colors.primary}
          />
        ) : null}
        <Icon
          type={icon.name}
          size={icon?.size ?? 80}
          viewSize={icon?.viewSize ?? 20}
          color={icon.color}
        />
        <HeaderStyle size={4}>{headerText}</HeaderStyle>
        <Text size="medium" align="center">
          {bodyText}
        </Text>
      </InfoCardContainer>
    </BaseModal>
  );
};

export default InfoCard;
